//Please add the language resource
const boxReportForm = {
  rfid:'Rfid',
  packerCode:'PackerCode',
  customerCode: 'CustomerCode',
  itrCode: 'ItrCode',
  receiveStatus: 'ReceiveStatus',
  useageStatus: 'UseageStatus',
  scStatus: 'ScStatus',
  receiveTime: 'ReceiveTime',
  useageTime:'UseageTime',
  orderNo:'OrderNo',
  shipTime:'ShipTime',
  receivingAddressDetail:'ReceivingAddressDetail',
  receivingContact:'ReceivingContact',
  receivingContactNumber:'ReceivingContactNumber',
  sku:'sku',
  packerName:'packerName',
  thirdCustomerName:'thirdCustomerName',
  email: 'Email',
  msg:{
  }
};
export default boxReportForm



// WEBPACK FOOTER //
// ./src/page/report/boxReportForm/lang/boxReportForm.en.js